<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select v-model="query.companyId" placeholder="公司" clearable class="handle-select mr10">
					<el-option v-for="item in companys" :label="item.companyName" :value="item.companyNo"></el-option>
				</el-select>
				<el-input v-model="query.likeLoginName" style="width: 150px;" placeholder="用户名称" clearable class="handle-input mr10"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="clickSearch">搜索</el-button>
				<el-button type="primary" @click="addAccountShow">添加</el-button>

			</div>
			<el-table :data="tableData" border>
				<el-table-column prop="companyName" label="公司"></el-table-column>
				<el-table-column prop="departName" label="部门"></el-table-column>
				<el-table-column prop="staffName" label="员工姓名"></el-table-column>
				<el-table-column prop="loginName" label="登录账号"></el-table-column>
				<el-table-column  label="角色">
					<template slot-scope="scope">
						<span v-if="scope.row.roleResps.length>0" v-for="(r,i) in scope.row.roleResps" :key="i">
							{{r.roleName}} &nbsp;&nbsp;&nbsp;
						</span>
					</template>
				</el-table-column>
				<el-table-column label="账号状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0">待生效</span>
						<span v-else-if="scope.row.status == 1">正常</span>
						<span v-else-if="scope.row.status == 2">冻结</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button title="修改" plain icon="el-icon-edit" @click="infoClick(scope.$index)" circle></el-button>
						<el-button title="修改密码" plain icon="el-icon-key" @click="passUpdate(scope.row)" circle></el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex" :page-size="query.pageRows"
				 :total="pageTotal" @current-change="handlePageChange" prev-click="pageChange(1)" next-click="pageChange(2)"></el-pagination>
			</div>

		</div>


		<el-dialog :title="editType==0?'新增':'修改'" :visible.sync="showEdit" width="30%" :show-close="false" :close-on-click-modal="false">

			<el-form :model="account">
				<el-row :gutter="5">
					<el-col :span="12">
					</el-col>
					<el-col :span="12">
					</el-col>
				</el-row>
				<el-row :gutter="5">
					<el-col :span="editType==0?12:24">
						<el-form-item label="登录名称">
							<el-input type="text" v-model="account.loginName" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="editType==0">
						<el-form-item label="密码" >
							<el-input type="password" v-model="account.password" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="5">
					<el-col :span="12">
						<el-form-item label="所属公司">
							<el-select v-model="account.companyId" value-key="companyId" placeholder="选择公司">
								<el-option v-for="item in companys" :label="item.companyName" :value="item.companyNo"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所属部门">
							<el-input type="text" v-model="account.departName" disabled autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="5">
					<el-col :span="12">
						<el-form-item label="所属员工">
							<el-input type="text" v-model="account.staffName" readonly></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="用户状态">
							<el-select v-model="account.status" placeholder="请选择">
								<el-option label="待生效" :value='0'></el-option>
								<el-option label="正常" :value='1'></el-option>
								<el-option label="冻结" :value='2'></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<div >
					<el-button v-if="account.staffName" type="warning"  @click="unbindStaff">员工解绑</el-button>
					<el-button v-if="!account.staffName"  type="primary" @click="showSelect">关联员工</el-button>
					<el-button @click="toChooseRole" type="success" >添加角色</el-button>
				</div>
				<div style="margin-top: 3px;border-top: 1px solid lightgrey;padding: 5px 5px">
					<el-tag style="margin-right: 3px;" :key="tag.id" v-for="tag in roles" closable @close="delRole(tag)">
						{{tag.roleName}}
					</el-tag>
				</div>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="showEdit = false">取 消</el-button>
				<el-button type="primary" @click="postRole">提交</el-button>
			</span>
		</el-dialog>


		<el-dialog title="角色" :visible="showChoose" :show-close="false" :close-on-click-modal="false">
			<chooseRole @choose="addRole"></chooseRole>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showChoose = false">关闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="选择员工" :visible="showStaffChoose" :show-close="false" :close-on-click-modal="false">
			<choose-staff @choose="addStaff"></choose-staff>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showStaffChoose = false">关闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="修改密码" :visible="showPass" width="20%" :show-close="false" :close-on-click-modal="false">
			
			<el-form :model="pass">
				<el-form-item label="用户名" >
					<el-input type="text" v-model="pass.loginName" readonly autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="新密码" >
					<el-input type="password" v-model="pass.newPass" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" >
					<el-input type="password" v-model="pass.newPassAgain" autocomplete="off"></el-input>
				</el-form-item>
			
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showPass = false">关闭</el-button>
				<el-button type="primary" @click="postPass">提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import chooseRole from './chooseRole.vue';
	import chooseStaff from './ChoseStaff.vue';
	import {mapState} from 'vuex';
	export default {
		data: function() {
			return {
				query: {
					status: null,
					likeLoginName: null,
					companyId: null,
					pageIndex: 1,
					pageRows: 10
				},
				tableData: [],
				pageTotal: 0,
				showEdit: false,
				editType: 0, //0添加 1修改
				account: {
					id: '',
					loginName: '',
					password: '',
					departName:'',
					roles: '',
					departId: '',
					orgName: '',
					status: 1,
					isValid: 1,
					staffName:''
				},
				pass: {
					id: '',
					loginName:'',
					newPass: '',
					newPassAgain: '',
					oldPass: ''
				},
				roles: [],
				showChoose: false,
				showStaffChoose: false,
				showPass: false
			}
		},
		computed:{
			...mapState(['companys']),
		},
		created() {
			this.handleSearch()
		},
		components: {
			chooseRole,
			chooseStaff
		},
		methods: {

			clickSearch: function() {
				this.query.pageIndex = 1;
				this.handleSearch();
			},
			handleSearch: function() {
				//查询

				this.HTTP.post('/system/user/queryPage', this.query).then(res => {

					if (res.data.code == 1) {
						this.tableData = res.data.rows
						this.pageTotal = res.data.counts
					}else{
						this.$message.error(res.data.message);
					}

				}).catch(err => {
					console.log(err)
				})
			},
			handlePageChange: function(e) {
				this.query.pageIndex = e
				this.handleSearch()
			},
			pageChange: function(type) {
				if (type == 1) {
					this.query.pageIndex -= 1;
				} else {
					this.query.pageIndex += 1;
				}

				this.handleSearch()
			},
			addAccountShow: function() {
				this.editType = 0
				this.showEdit = true
				this.account = {}
			},
			toChooseRole: function() {
				this.showChoose = true
			},
			addRole: function(role) {
				for (let i = 0; i < this.roles.length; i++) {
					if (role.id == this.roles[i]) {
						this.$message('已选择该角色')
						return
					}
				}
				this.roles.push(role);
				this.showChoose = false
			},
			addStaff(staff){
				this.showStaffChoose = false;
				this.account.staffId = staff.staffNo;
				this.account.departId = staff.deptNo;
				this.account.companyId = staff.companyNo;
				this.account.companyName = staff.companyName;
				this.account.departName = staff.departName;
				this.account.positionName = staff.positionName;
				this.account.staffName = staff.name;
			},
			unbindStaff(){
				this.$confirm('请确认是否解绑?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.HTTP.post("/system/user/unbindStaff",this.account).then(res=>{
						if (res.data.success){
							this.$message.success("解绑成功!");
						}else{
							this.$message.error(res.data.message);
						}
						this.account = {};
					})
				}).catch(() => {
				});
			},
			showSelect(){
				this.showStaffChoose = true;
			},
			delRole: function(t) {
				for (let i = 0; i < this.roles.length; i++) {
					if (t.id == this.roles[i].id) {
						this.roles.splice(i, 1)
						return
					}
				}
			},
			postRole: function() {
				if (!this.roles || this.roles.length==0){
					this.$message.error('请选择角色');
					return
				}
				this.account.roles = [];
				for (let i in this.roles){
					this.account.roles.push(this.roles[i].id);
				}
				if (!this.account.loginName){
					this.$message.error('请输入用户名');
					return;
				}
				if (!this.account.password){
					this.$message.error('请输入密码');
					return;
				}
				if (!this.account.companyId){
					this.$message.error('请选择公司');
					return;
				}
				this.HTTP.post('/system/user/saveOrUpdate', this.account)
					.then(res => {
						if (res.data.code == 1) {
							this.showEdit = false
							this.$message.success("更新成功");
							this.handleSearch()
						} else {
							this.$message(res.data.message);
						}
						this.account = {};
					})
					.catch(err => {})
			},
			infoClick: function(i) {
				this.account = this.tableData[i]
				debugger
				if(this.account.roleIdList && this.account.roleIdList.length>0) {
					this.HTTP.post("/system/role/findByRoleIds",this.account.roleIdList).then(res=>{
						debugger
						if (res.data.success){
							this.roles = res.data.rows;
						}else{
							this.$message.error(res.data.message);
						}
					})
				}else{
					this.roles = []
				}
				this.editType = 1
				this.showEdit = true
			},
			passUpdate: function(data) {
				this.pass = {
					id: data.id,
					loginName:data.loginName,
					newPass: '',
					newPassAgain: '',
					oldPass: ''
				}
				this.showPass = true
			},
			postPass: function() {
				if (!this.pass.newPass){
					this.$message.error("请输入密码");
					return
				}
				if (this.pass.newPass.length<6){
					this.$message.error("密码长度至少6位");
					return
				}
				if (!this.pass.newPassAgain){
					this.$message.error("请输入重复密码");
					return
				}

				if (this.pass.newPass!=this.pass.newPass){
					this.$message.error("两次输入的密码不一致");
					return
				}
				this.HTTP.post('/system/user/updatePasswordByAdmin', this.pass)
				.then(res => {
					if(res.data.code == 1) {
						this.showPass = false
						this.$message.success("更新成功");
					}else {
						this.$message.error(res.data.message);
					}
					this.pass = {};
				})
				.then(err => {
					
				})
			}

		}
	}
</script>

<style>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.info-div {
		display: flex;
		justify-content: space-around;
		margin-top: 5px;
		font-size: 13px;
	}

	.info-span1 {
		width: 230px;
		font-size: 15px;
	}

	.info-span2 {
		width: 230px;
		font-size: 15px;
	}

	.info-title {
		margin-right: 4px;
		color: #000000;
	}
</style>
